const FormTextInput = (props) => {
  return (
    <>
      <input
        type="text"
        {...props}
        className="rounded-md min-w-full border-gray-300"
      />
    </>
  );
};

export default FormTextInput;
